<template>
  <div class="page">
    <el-form label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="仓库名:">
            <el-input v-model="queryForm.warehouseName" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="仓级筛选:">
            <el-select v-model="queryForm.warehouseLevel" clearable>
              <el-option label="全部" :value="null"></el-option>
              <el-option label="一级" :value="1"></el-option>
              <el-option label="二级" :value="2"></el-option>
              <el-option label="三级" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="empty">重置</el-button>
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <!--工具条-->
    <div id="content-box">
      <el-table :data="tableList" highlight-current-row v-loading="tableLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%"
        border>
        <el-table-column prop="warehouseId" label="仓库ID" min-width="70" align="center"></el-table-column>
        <el-table-column prop="warehouseName" label="仓库名" min-width="80" align="center"></el-table-column>
        <el-table-column prop="warehouseLevel" label="仓级" min-width="70" align="center"></el-table-column>
        <el-table-column prop="warehouseSpace" label="仓位" min-width="120" align="center"></el-table-column>
        <el-table-column label="发货区域" min-width="150" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.showDeliveryArea">{{ scope.row.deliveryAreaStr }}</span>
            <el-button v-if="!scope.row.showDeliveryArea" size="small" type="primary" :loading="scope.row.showLoading"
              @click="getDeliveryAreasStr(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="stock" label="库存量" min-width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text"
              @click="()=>{$router.push(`/Warehouse/barCode?skuId=${$route.query.skuId}&warehouseId=${scope.row.warehouseId}&warehouseName=${scope.row.warehouseName}`)}">
              {{scope.row.stock}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="70" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
              @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" class="pagination" :total="total"
        :current-page="queryForm.pageIndex" :pageSize="queryForm.pageSize" @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>
    </div>
    <!-- 库存编辑 -->
    <el-dialog title="库存编辑" :visible.sync="warehouseFormVisible" :close-on-click-modal="false">
      <el-form :model="warehouseForm" label-width="120px" ref="warehouseForm">
        <el-form-item label="库存：">
          <el-input v-model="warehouseForm.stock" auto-complete="off" placeholder="请输入库存"></el-input>
        </el-form-item>
        <el-form-item label="仓位：">
          <el-input v-model="warehouseForm.warehouseSpace" auto-complete="off" placeholder="请输入仓位"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="warehouseForm.note" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="warehouseFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmitInventory" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!-- 添加库存 -->
    <el-dialog title="添加库存" :visible.sync="addInventoryDialog" v-if="addInventoryDialog" :close-on-click-modal="false">
      <el-form :model="addInventoryForm" label-width="120px" :rules="addInventoryFormRules" ref="addInventoryForm">
        <el-form-item label="仓库" prop="warehouseId">

          <el-cascader placeholder="请选择仓库（可搜索）" style="width: 400px" v-model="addInventoryForm.warehouseId"
            :options="warehouseTreeList" filterable clearable change-on-select></el-cascader>

          <!-- <el-select
              filterable
              remote
              v-model="addInventoryForm.warehouseId"
              placeholder="请输入仓库（可搜索）"
              clearable
              :remote-method="remoteMethod"
              @blur="select_blur_warehouse"
            >
              <el-option
                v-for="(item,index) in warehouseList"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select> -->
        </el-form-item>

        <el-form-item label="库存：" prop="stock">
          <el-input type="age" v-model.number="addInventoryForm.stock" auto-complete="off" placeholder="请输入库存">
          </el-input>
        </el-form-item>
        <el-form-item label="仓位：">
          <el-input v-model="addInventoryForm.warehouseSpace" auto-complete="off" placeholder="请输入仓位"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addInventoryDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitAddInventory" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import toolbar from "../../components/Toolbar";
import {
  GetAllInventoryItems,
  GetAllWarehouse,
  InventoryResetStock,
  GetDeliveryAreas,
  AddInventoryItem,
  GetTreeWarehouse
} from "../../api/api";
export default {
  components: {
    toolbar
  },
  data() {
    return {
      buttonList_toolBar: [],
      buttonList_table: [],
      inventoryId: this.$route.query.id ? this.$route.query.id : null,
      tableList: [],
      tableLoading: false,
      total: 0,
      queryForm: {
        warehouseName: null,
        warehouseLevel: null,
        pageIndex: 1,
        pageSize: 10
      },
      warehouseFormVisible: false,
      formData: {
        inventoryId: null,
        warehouseName: null,
        warehouseId: null,
        warehouseSpace: null,
        stock: 0
      },
      warehouseForm: {
        warehouseId: null,
        stock: 0,
        warehouseSpace: null,
        note: null
      },
      submitLoading: false,

      addInventoryDialog: false,
      addInventoryForm: {
        warehouseId: null,
        stock: null,
        warehouseSpace: null,
        inventoryId: parseInt(this.$route.query.id)
      },
      addInventoryFormRules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        stock: [
          { required: true, message: '请输入库存' },
          { type: 'number', message: '库存必须为数字' }
        ],
      },
      warehouseList: [],
    };
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;

    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
  mounted() {
    this.getWarehouseList();
    this.getTableList();
    this.getWarehouseTreeList();
  },
  methods: {
    getWarehouseTreeList() {
      GetTreeWarehouse().then((res) => {
        this.warehouseTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    // 递归封装菜单树
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    getWarehouseList() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      let that = this;
      GetAllWarehouse(params).then((res) => {
        if (res.data.success) {
          that.warehouseList = res.data.result.items;
        }
      });
    },
    select_blur_warehouse() {
      this.getWarehouseList();
    },
    remoteMethod(query) {
      let that = this;
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      if (query !== '') {
        params.Name = query;
      }
      GetAllWarehouse(params).then((res) => {
        if (res.data.success) {
          that.warehouseList = res.data.result.items;
        }
      });
    },
    getDeliveryAreasStr(row) {
      let params = {
        WarehouseId: row.warehouseId,
        MaxLevel: 1,
      }
      row.showLoading = true;
      GetDeliveryAreas(params).then((res) => {
        row.showLoading = false;
        row.showDeliveryArea = true;
        row.deliveryAreaStr = res.data.result.join(',');
      });
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleSelect(item) {
      this.formData.warehouseId = item.id;
    },
    getTableList() {
      this.tableLoading = true;
      let params = {
        inventoryId: this.inventoryId,
        warehouseName: this.queryForm.warehouseName,
        warehouseLevel: this.queryForm.warehouseLevel,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      that.tableLoading = true;
      GetAllInventoryItems(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        res.data.result.items.forEach(x => {
          x.showDeliveryArea = false;
          x.deliveryAreaStr = null;
          x.showLoading = false;
        });
        that.tableList = res.data.result.items;
      });
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getTableList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    },
    empty() {
      this.queryForm.warehouseName = null;
      this.queryForm.warehouseLevel = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    },
    editInventory(item, index, row) {
      this.warehouseFormVisible = true;
      this.warehouseForm = {
        warehouseId: row.warehouseId,
        stock: row.stock,
        warehouseSpace: row.warehouseSpace,
        note: row.note
      }
    },
    editSubmitInventory() {
      let that = this
      let params = {
        inventoryId: that.inventoryId,
        warehouseId: that.warehouseForm.warehouseId,
        stock: that.warehouseForm.stock,
        note: that.warehouseForm.note,
        warehouseSpace: that.warehouseForm.warehouseSpace
      };
      that.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(() => {
        InventoryResetStock(params).then((res) => {
          that.submitLoading = false;
          if (res.data.success) {
            that.$message.success('编辑成功');
            that.warehouseFormVisible = false;
            that.getTableList();
          } else {
            that.$message.error(res.data.error.message);
          }
        });
      })
    },
    addInventory() {
      this.addInventoryDialog = true;
      this.addInventoryForm.warehouseId = null;
      this.addInventoryForm.stock = null;
      this.addInventoryForm.warehouseSpace = null;
    },
    submitAddInventory() {
      let that = this;
      that.$refs.addInventoryForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            let warehouseId = that.addInventoryForm.warehouseId;
            that.addInventoryForm.warehouseId = warehouseId[warehouseId.length - 1]
            AddInventoryItem(that.addInventoryForm).then((res) => {
              that.submitLoading = false;
              if (res.data.success) {
                that.$message.success('新增成功');
                that.addInventoryDialog = false;
                that.getTableList();
              } else {
                that.$message.error(res.data.error.message);
              }
            });
          }).catch(() => { });
        }
      });
    }
  }
};
</script>
<style scoped>
/* #main-box {
  width: 100%;
  height: 100%;
  padding-top: 90px;
}

#btn-box {
  position: fixed;
  height: 110px;
  top: 94px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-top: 5px;
}

#btn-box /deep/ .el-form-item {
  margin-bottom: 10px;
}

#content-box {
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}

.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
} */
</style>
